import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('shared.hooks.useTimeZoneSelect', {
    myTz: 'my time zone',
    orgTz: 'organisation time zone',
});
